
import { ValidateToken } from "@/utils/authentication";
import { Navigate, Outlet } from "react-router-dom";

type Props = {
  roles: string[],
  fallbackRoute?: string; // Optional fallback route for unauthorized access
}

/**
 * This function protects routes based on user roles without logging them out
 * @returns the requested page if the User has the required roles, fallback route or error page otherwise
 */
function SubProtectedRoute({
  roles,
  fallbackRoute = "/dashboard",
}: Props) {
  const hasRequiredRole = ValidateToken(roles);

  if (!hasRequiredRole) {
    return <Navigate to={fallbackRoute} replace />;
  } else {
    return <Outlet />;
  }
}

export default SubProtectedRoute;
